<template>
  <div class="banner component review-content">
    <div class="columns is-desktop is-gapless reviewContainer">
      <div class="column">
        <div class="columns is-centered is-gapless is-desktop">
          <div class="review-content__heading">
            <div v-if="reviews.Ribbon" class="review-content__heading--range">
              <span>{{ reviews.Ribbon }}</span>
            </div>
            <div class="review-content__heading--title">
              {{ reviews.SubTitle }}
            </div>
            <div class="review-content__heading--subtitle" v-titleSup="reviews.Title"></div>
          </div>
        </div>
      </div>
      <div class="column reviewcolumn">
        <div class="review-content__list">
          <div
            v-for="(review, i) in reviews.Reviews"
            v-bind:key="i"
            class="review-content__list-item"
          >
            <div class="review-content__list-item--inner">
              <div class="rating__stars" v-if="!review.isRatingDisabled">
                <div class="rating__stars-outline">
                  <svg
                    v-for="(index, key) in maxRating"
                    class="rating__star"
                    aria-hidden="true"
                    :key="key"
                    v-once
                  >
                    <use
                      class="use"
                      xlink:href="#star-outline"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                </div>
                <div class="rating__stars-filled">
                  <svg
                    v-for="(index, key) in maxRating"
                    class="rating__star"
                    aria-hidden="true"
                    :key="key"
                    v-once
                  >
                    <use
                      class="use"
                      xlink:href="#star-filled"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                </div>
              </div>
              <div
                class="review-content__list-item--title"
                v-htmlsafe="review.Title"
              ></div>
              <div
                class="review-content__list-item--reviewcount"
                v-htmlsafe="review.ReviewContent"
              ></div>
              <div
                class="review-content__list-item--author"
                v-htmlsafe="review.Author"
              ></div>
            </div>
          </div>
        </div>
        <div class="gradientClass"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'reviewcontent',
  data() {
    return {
      maxRating: 5,
    };
  },
  props: {
    reviews: {
      type: Object,
    },
  },
};
</script>
<style lang="scss" src="./review-content.scss"></style>
